// Markdown formatting utilities
export const formatMarkdown = (text) => {
  if (!text) return '';
  
  // Preserve inline code blocks: `code` to <code>code</code>
  let formatted = text.replace(/`([^`]+)`/g, '<code>$1</code>');
  
  // Format bold text: **text** or __text__ to <strong>text</strong>
  formatted = formatted.replace(/\*\*(.*?)\*\*|__(.*?)__/g, '<strong>$1$2</strong>');
  
  // Format italic text: *text* or _text_ to <em>text</em>
  formatted = formatted.replace(/(?<!\*)\*((?!\*).+?)\*(?!\*)|(?<!_)_((?!_).+?)_(?!_)/g, '<em>$1$2</em>');
  
  // Format links: [text](url) to <a href="url">text</a>
  formatted = formatted.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  
  // Format headers: # Header to <h1>Header</h1>, ## Header to <h2>Header</h2>, etc.
  formatted = formatted.replace(/^# (.*?)$/gm, '<h1>$1</h1>');
  formatted = formatted.replace(/^## (.*?)$/gm, '<h2>$1</h2>');
  formatted = formatted.replace(/^### (.*?)$/gm, '<h3>$1</h3>');
  formatted = formatted.replace(/^#### (.*?)$/gm, '<h4>$1</h4>');
  
  // Process lists more carefully
  // First, identify list blocks
  const listBlockRegex = /((?:^- .*$\n?)+)|((?:^\d+\. .*$\n?)+)/gm;
  formatted = formatted.replace(listBlockRegex, (match) => {
    if (match.startsWith('- ')) {
      // Unordered list
      return '<ul>' + match.replace(/^- (.*)$/gm, '<li>$1</li>') + '</ul>';
    } else {
      // Ordered list
      return '<ol>' + match.replace(/^\d+\. (.*)$/gm, '<li>$1</li>') + '</ol>';
    }
  });
  
  // Format paragraphs: add <p> tags to text blocks that aren't already formatted
  const paragraphLines = formatted ? formatted.split('\n') : [];
  formatted = paragraphLines.map(line => {
    // Skip lines that already have HTML tags
    if (!line || line.match(/^<(\/?(?:h[1-6]|ul|ol|li|code|strong|em|a|p))/) || line.trim() === '') {
      return line;
    }
    return `<p>${line}</p>`;
  }).join('\n');
  
  // Format line breaks: replace \n with <br> within paragraphs
  formatted = formatted.replace(/<p>(.*?)<\/p>/gs, (match, p1) => {
    return `<p>${p1.replace(/\n/g, '<br>')}</p>`;
  });
  
  return formatted;
};

// Utility function to generate conversation title from first message
export const generateConversationTitle = (message) => {
  if (!message) return 'New Conversation';
  return message.length > 30 ? message.substring(0, 30) + '...' : message;
};

// Utility function to scroll to bottom of messages
export const scrollToBottom = (ref, delay = 50) => {
  setTimeout(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, delay);
};

// Utility function to copy text to clipboard
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};